import { useContext } from 'react';
import {
  COLOR1,
  COLOR2,
  COLOR4,
  RADIO_COLOR,
  ORIENTAL_D_GRAY,
  ORIENTAL_ORANGE,
} from '../../../constants';
import LeadGenerationContext from '../../../context/LeadGenerationContext';

export const ProductUIStyles = (theme) => {
  const leadGenerationContext = useContext(LeadGenerationContext);
  return {
    multiCountryDesc: {
      font: 'normal 600 16px/14px Arial',
      color: '#000000',
    },
    select_inputs_placeholder: {
      background: 'rgba(85, 88, 88, 0.02) 0% 0% no-repeat padding-box',
      textAlign: 'left',
      fontWeight: 300,
      lineHeight: '16px',
      fontStyle: 'normal',
      fontSize: '14px',
      letterSpacing: '0.1px',
      color: ORIENTAL_D_GRAY,
      opacity: 0.8,
    },
    subQuesPage: {
      paddingRight: '20px',
      '@media (max-width: 599px)': {
        paddingRight: '0',
        marginTop: '20px',
      },
    },
    radioLabelStyle: {
      marginLeft: '15px',
      font: 'normal 400 16px/18px Arial',
      display: 'inline',
      color: '#000000',
      cursor: 'pointer',
    },
    radioRoot: {
      width: 0,
      height: '19px',
      paddingTop: 0,
      paddingBottom: 0,
      color: '#661c69',
    },
    personal_button_container: {
      '@media (max-width: 650px)': {
        justifyContent: 'center',
        display: 'flex',
      },
    },
    product_grid: {
      boxSizing: 'border-box',
      border: '1px solid #D0D0D0',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.21)',
      borderRadius: '6px',
      '@media (max-width: 599px)': {
        border: 'none',
        boxShadow: 'none',
      },
    },
    product_grid_margin: {
      background: '#FFFFFF',
      border: '1px solid #D0D0D0',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.21)',
      borderRadius: '6px',
      '@media (max-width: 599px)': {
        padding: '0',
        border: 'none',
        borderRadius: '0',
        boxShadow: 'none',
      },
    },
    questionContainerEmp: {
      margin: '0 30px 30px',
      borderTop: '1px solid #E6E6E6',
      paddingTop: '30px',
      '@media (max-width: 599px)': {
        margin: '0',
      },
    },
    interestPaymentContainer: {
      margin: '0 30px 30px',
      borderTop: '1px solid #E6E6E6',
      '@media (max-width: 600px)': {
        margin: '0',
      },
    },
    questionContainerProd: {
      paddingTop: '25px',
      paddingRight: '30px',
      paddingBottom: '0px',
      paddingLeft: '30px',
      border: '0.25px solid #FFFFFF',
      opacity: 1,
      borderRadius: '6px',
      '@media (max-width: 599px)': {
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        marginTop: '-40px',
      },
    },
    debCard: {
      padding: '0px 30px',
      '@media (max-width: 600px)': {
        padding: '0',
      },
    },
    questionContainerWithhold: {
      padding: '0px 30px',
      '@media (max-width: 599px)': {
        padding: '0',
      },
    },
    star_style: {
      textAlign: 'center',
      font: 'normal normal normal 22px/26px Arial',
      letterSpacing: '0.15px',
      color: ORIENTAL_ORANGE,
      opacity: 1,
    },
    titleborder: {
      paddingTop: '30px',
      borderTop: '1px solid #E6E6E6',
      '@media (max-width: 600px)': {
        paddingTop: '20px',
      },
    },
    titleborderdeposite: {
      paddingTop: '24px',
      borderTop: '1px solid #E6E6E6',
      '@media (max-width: 600px)': {
        paddingTop: '20px',
      },
    },
    titleInterestPaymentMethod: {
      margin: '30px 0',
      '@media (max-width: 600px)': {
        paddingTop: '20px',
      },
    },
    quesTitleStyle: {
      font: 'normal 700 24px/28px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
      opacity: 1,
      '@media (max-width: 600px)': {
        font: '700 22px/32px Arial',
      },
    },
    quesTitleBundleStyle: {
      font: 'normal 700 16px/100% "TTNORMSPROBOLD"',
      letterSpacing: '0px',
      textAlign: 'center',
      color: COLOR1,
      opacity: 1,
    },
    quesBundleSubtitleContainer: {
      margin: '0 0 24px 0',
    },
    widgetContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'top',
      gap: '8px',
      paddingLeft: '9px',
    },
    widgetContainerFont: {
      font: 'normal 400 16px/100% Arial',
      letterSpacing: '0px',
      textAlign: 'start',
      opacity: 1,
    },
    questionContainerEmpBundle: {
      borderTop: '1px solid #E6E6E6',
      paddingTop: '24px',
    },
    empStatusBundle: {
      fontFamily: 'TTNormsProBold',
      fontStyle: 'normal',
      fontWeight: '700',
      fontSize: '16px',
      lineHeight: '100%',
      letterSpacing: '0px',
      textAlign: 'center',
    },
    quesTitleStyleDeposite: {
      font: 'normal 700 24px/28px TTNormsProBold',
      letterSpacing: '0.11px',
      color: COLOR1,
      opacity: 1,
      '@media (max-width: 600px)': {
        font: '700 22px/32px TTNormsProBold',
      },
    },
    radioLayout: {
      marginTop: '34px',
      marginBottom: '30px',
      '@media (max-width: 600px)': {
        marginTop: '20px',
        marginBottom: '20px',
      },
    },
    radioLayoutDeposite: {
      marginTop: '34px',
      marginBottom: '27px',
      '@media (max-width: 600px)': {
        marginTop: '23px',
        marginBottom: '40px',
      },
    },
    quesTitleSubHeadingStyle: {
      font: 'normal 400 16px/18px Arial',
      letterSpacing: '0.11px',
      opacity: 1,
      marginTop: '20px',
      '@media (max-width: 600px)': {
        marginTop: '12px',
      },
    },
    quesTitleBankingSubHeading: {
      font: 'normal normal 700 16px/18px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
      opacity: 1,
      marginTop: '20px',
      '@media (max-width: 600px)': {
        marginTop: '12px',
      },
    },
    feeWaivedText: {
      font: 'normal 400 16px/18px Arial',
      letterSpacing: '0.11px',
      marginLeft: '6px',
      color: COLOR1,
      opacity: 1,
      marginTop: '20px',
      '@media (max-width: 600px)': {
        marginTop: '12px',
      },
    },
    imageIcon: {
      '@media (min-width: 1432px)': {
        marginTop: '15px',
      },
    },
    label_title: {
      marginBottom: '10px',
      font: 'normal 700 14px/18px Arial',
      letterSpacing: '0.1px',
      textAlign: 'left',
    },
    group_sub_select: {
      marginBottom: '28px',
      paddingRight: '20px',
      '@media (max-width: 600px)': {
        paddingRight: '0px',
        marginBottom: '20px',
      },
    },
    ira_group_sub_select: {
      marginBottom: '20px',
      paddingRight: '50px',
      '@media (max-width: 600px)': {
        paddingRight: '0',
      },
    },
    group_sub_select_width: {
      // background: '#FFFFFF',
      opacity: 1,
      height: '48px',
      fontWeight: 400,
      fontStyle: 'normal',
      fontSize: '16px',
      lineHeight: '18px',
      textAlign: 'left',
      letterSpacing: '0.1px',
      // color: '#808285',
      '& .MuiOutlinedInput-input': {
        padding: '12px 16px',
        // width: '500px',
      },
      '& fieldset': {
        borderRadius: '6px',
        border: '1px solid #E4E9F2',
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
    IRA_select_width: {
      // background: 'rgba(85, 88, 88, 0.02) 0% 0% no-repeat padding-box',
      opacity: 1,
      height: '41px',
      fontWeight: 300,
      fontStyle: 'normal',
      fontSize: '14px',
      lineHeight: '16px',
      textAlign: 'left',
      letterSpacing: '0.1px',
      // color: COLOR1,
      '& .MuiOutlinedInput-input': {
        padding: '11.5px 14px 5px 14px',
      },
      '& fieldset': {
        borderRadius: '2px',
        border: `0.25px solid ${ORIENTAL_D_GRAY}`,
      },
      '@media (max-width: 600px)': {
        width: '100%',
      },
    },
    mini_doc_upload: {
      marginTop: '15px',
      marginLeft: '52px',
      '@media (max-width: 600px)': {
        marginTop: '15px',
      },
      '@media (max-width: 400px)': {
        marginLeft: 0,
      },
    },
    consent_checkbox: {
      maxWidth: '30px',
    },
    act22_icon_styles: {
      fontSize: '13px',
      display: 'flex',
      alignItems: 'flex-start',
      '@media (max-width: 400px)': {
        marginLeft: 0,
      },
    },
    list_style_doc: {
      margin: '0 0 0 9px',
      '@media (max-width: 400px)': {
        padding: '0 0 0 6px',
      },
    },
    docStyle: {
      font: 'normal normal 400 16px/18px Arial',
      letterSpacing: '0.1px',
      color: theme?.palette?.primary?.main,
      marginLeft: '15px',
    },
    product_stepper: {
      width: '100%',
      margin: '37px 30px 35px 50px',
      '@media (max-width: 650px)': {
        margin: '25px 25px 5px 25px',
      },
      '@media (max-width: 600px)': {
        margin: '37px 50px 25px 50px',
      },
    },
    error_message_product: {
      font: 'normal normal normal 14px/16px Arial',
      letterSpacing: '0.1px',
      color: COLOR2,
      opacity: 1,
      marginTop: '4px',
      display: 'block',
    },
    select_icon: {
      color: RADIO_COLOR,
      opacity: 1,
      '@media (max-width: 340px)': {
        right: 0,
      },
    },
    select_style: {
      background: 'rgba(85, 88, 88, 0.02) 0% 0% no-repeat padding-box',
      textAlign: 'left',
      fontWeight: 300,
      lineHeight: '16px',
      fontStyle: 'normal',
      fontSize: '14px',
      letterSpacing: '0.1px',
      color: COLOR1,
      opacity: 1,
    },
    contact_grid_margin: {
      marginLeft: '48px',
      marginRight: '48px',
      '@media (max-width: 960px)': {
        marginRight: '44px',
        marginLeft: '44px',
      },
      '@media (max-width: 650px)': {
        marginRight: '25px',
        marginLeft: '25px',
      },
      '@media (max-width: 330px)': {
        marginRight: '20px',
        marginLeft: '20px',
      },
    },
    contact_container: {
      background: `${COLOR4} 0% 0% no-repeat padding-box`,
      opacity: 1,
    },
    heading_h6: {
      fontSize: '16px',
      '@media (max-width: 600px)': {
        fontSize: '14px',
      },
    },
    // checkbox styles
    checkbox_label_style: {
      marginLeft: '2px',
      textAlign: 'left',
      font: 'normal normal 300 16/18px Arial',
      letterSpacing: '0.11px',
      color: COLOR1,
      opacity: 1,
      '@media (max-width: 550px)': {
        font: 'normal normal 300 14/16px Arial',
      },
    },
    checkbox_label_newstyle: {
      marginLeft: '-10px',
      '@media (max-width: 650px)': {
        marginLeft: '-4px',
      },
    },
    checkbox_content_position: {
      display: 'block',
      position: 'relative',
      top: '-10px',
      left: '32px',
      width: 'fit-content',
      marginRight: '30px',
      '@media (max-width: 600px)': {
        top: '-18px',
        left: '27px',
      },
    },
    checkbox_content_adjust_for_info: {
      top: '-22px',
      '@media (min-width: 850px)': {
        top: '-18px',
        left: '27px',
      },
    },
    checkbox_content_position_widget: {
      display: 'block',
      position: 'relative',
      top: '-22px',
      left: '30px',
      width: 'fit-content',
      marginRight: '30px',
    },
    interest_payment_method_padding: {
      paddingRight: '50px',
      '@media (max-width: 960px)': {
        paddingRight: '0',
      },
      '@media (max-width: 600px)': {
        paddingRight: '0',
      },
    },
    error_message: {
      font: 'normal normal normal 14px/16px Arial',
      letterSpacing: '0.1px',
      color: COLOR2,
      opacity: 1,
      position: 'relative',
      top: '3px',
      display: 'block',
    },
  };
};
